<template>
  <span
    class="bto-sb-favorite"
    :class="{ 'bto-sb-favorite-active': isFavorite() }"
    @click.stop.prevent="changeFavorite()">
    <span></span>
  </span>
</template>
<script>
  export default {
    name: 'ToggleFavorite',
    props: {
      favType: {
        type: Number,
        default: 0,
        required: true
      },
      category: {
        type: Object,
        default: () => null,
      },
      tournament: {
        type: Object,
        default: () => null,
      },
      sport: {
        type: Object,
        default: () => null,
      }
    },
    methods: {
      /**
       * createRouteParams is private method to create URI address for opening the tournament page
       * @return object
       */
      createRouteParams() {
        if (this.favType === 1) {
          return {
            sport: this.sport.name,
            sportId: this.sport.id,
          }
        }
        return {
          dateFilter: 'all',
          sport: this.sport.name,
          sportId: this.sport.id,
          category: this.category ? (this.category.categoryName || this.category.name) : null,
          categoryId: this.category ? (this.category.categoryId || this.category.id).toString() : null,
          tournament: this.tournament ? (this.tournament.name || this.tournament.tournamentName) : null,
          tournamentId: this.tournament ? `${this.tournament.id}` : null,
          cType: this.tournament ? this.getTournamentType() : this.getCategoryType()
        };
      },
      isFavorite() {
        switch (this.favType) {
          case 1:
            return this.isFavoriteSport();
          case 2:
            return this.isFavoriteCategory();
          case 3:
            return this.isFavoriteTournament();
        }
      },
      isFavoriteSport() {
        if (!this.sport) {
          return false;
        }
        const sportId = this.sport.id;
        return this.$store.state.favoritesModule.sports.findIndex(s => s.sportId === sportId) > -1;
      },
      isFavoriteCategory() {
        if (!this.category) {
          return false;
        }
        const categoryId = (this.category.categoryId || this.category.id).toString();
        return this.$store.state.favoritesModule.categories.findIndex(c => c.categoryId === categoryId) > -1;
      },
      isFavoriteTournament() {
        if (!this.tournament) {
          return false;
        }
        const tournamentId = `${this.tournament.id}`;
        return this.$store.state.favoritesModule.tournaments.findIndex(t => t.tournamentId === tournamentId) > -1;
      },
      changeFavorite() {
        switch (this.favType) {
          case 1:
            this.changeFavoriteSport();
            break;
          case 2:
            this.changeFavoriteCategory();
            break;
          case 3:
            this.changeFavoriteTournament();
            break;
        }
      },
      /**
       * changeFavoriteSport add/remove sport as favorite
       */
      changeFavoriteSport() {
        if (this.isFavoriteSport()) {
          this.$store.commit('removeFavoriteSport', this.sport.id);
        }
        else {
          const sportParams = this.createRouteParams();
          this.$store.commit('addFavoriteSport', sportParams);
        }
      },
      /**
       * changeFavoriteTournament add/remove tournament as favorite
       */
      changeFavoriteTournament() {
        if (this.isFavoriteTournament()) {
          this.$store.commit('removeFavoriteTournament', `${this.tournament.id}`);
        }
        else {
          const tournamentParams = this.createRouteParams();
          this.$store.commit('addFavoriteTournament', tournamentParams);
        }
      },
      /**
       * changeFavoriteCategory add/remove category as favorite
       */
      changeFavoriteCategory() {
        if (this.isFavoriteCategory()) {
          this.$store.commit('removeFavoriteCategory', (this.category.categoryId || this.category.id).toString());
        }
        else {
          const catParams = this.createRouteParams();
          this.$store.commit('addFavoriteCategory', catParams);
        }
      },
      getTournamentType() {
        return this.tournament.cType || (this.tournamentisGroup ? 4 : 3);
      },
      getCategoryType() {
        return this.category.cType || (this.category.isGroup ? 2 : 1);
      }
    },
  }
</script>